export const NodeType = {
  WEBHOOK_TRIGGER: "webhook_trigger",
  ASSISTANT: "assistant",
  EXTERNAL_API: "external_api",
  CONDITIONAL: "conditional",
  WAIT_FOR_CALLBACK: "wait_for_callback",
  DELAY: "delay",
  END: "end",
} as const;

export type NodeType = (typeof NodeType)[keyof typeof NodeType];

export const AssistantNodeAction = {
  VOICE_CALL: "voice_call",
  WHATSAPP_MESSAGE: "whatsapp_message"
} as const;

export type AssistantNodeAction =
  (typeof AssistantNodeAction)[keyof typeof AssistantNodeAction];

export const ConditionalNodeType = {
  CONDITIONAL_RULE: "rules",
} as const;

export type ConditionalNodeType =
  (typeof ConditionalNodeType)[keyof typeof ConditionalNodeType];
